import {
  SAVE_QUOTES_LIST,
  SAVE_QUOTE_DETAILS
} from 'redux/constants/Quotes';

const theme = (state = {}, action) => {
  switch (action.type) {
  case SAVE_QUOTES_LIST:
    return {
      ...state,
      list: action.payload
    };
  case SAVE_QUOTE_DETAILS:
    return {
      ...state,
      details: action.payload
    };
  default:
    return state;
  }
};

export default theme